import type { FC } from "react";
import { useTranslation } from "react-i18next";

interface IInvestigationHistoryRowHeadProps {
  label: string;
  time: string;
  /** When set, the head is a button that moves the replay to the row's moment. */
  onSeek?: () => void;
}

/** A History row's label and time — a button only when the row can be replayed. */
export const InvestigationHistoryRowHead: FC<
  IInvestigationHistoryRowHeadProps
> = ({ label, time, onSeek }) => {
  const { t } = useTranslation();

  if (!onSeek) {
    return (
      <div className="history-head">
        <span className="history-label">{label}</span>
        <span className="history-time">{time}</span>
      </div>
    );
  }

  return (
    <button
      type="button"
      className="history-head"
      title={t("rideMap.investigation.history.seek")}
      onClick={onSeek}
    >
      <span className="history-label">{label}</span>
      <span className="history-time">{time}</span>
    </button>
  );
};
